import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PetitionEducation } from './petition-education.model';
import * as PetitionEducationActions from './petition-education.actions';

export const petitionEducationsFeatureKey = 'petitionEducations';

export interface State extends EntityState<PetitionEducation> {
  // additional entities state properties
}

export const adapter: EntityAdapter<PetitionEducation> = createEntityAdapter<PetitionEducation>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(PetitionEducationActions.addPetitionEducation,
    (state, action) => adapter.addOne(action.petitionEducation, state)
  ),
  on(PetitionEducationActions.upsertPetitionEducation,
    (state, action) => adapter.upsertOne(action.petitionEducation, state)
  ),
  on(PetitionEducationActions.addPetitionEducations,
    (state, action) => adapter.addMany(action.petitionEducations, state)
  ),
  on(PetitionEducationActions.upsertPetitionEducations,
    (state, action) => adapter.upsertMany(action.petitionEducations, state)
  ),
  on(PetitionEducationActions.updatePetitionEducation,
    (state, action) => adapter.updateOne(action.petitionEducation, state)
  ),
  on(PetitionEducationActions.updatePetitionEducations,
    (state, action) => adapter.updateMany(action.petitionEducations, state)
  ),
  on(PetitionEducationActions.deletePetitionEducation,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(PetitionEducationActions.deletePetitionEducations,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(PetitionEducationActions.loadPetitionEducations,
    (state, action) => adapter.setAll(action.petitionEducations, state)
  ),
  on(PetitionEducationActions.clearPetitionEducations,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
